import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessPanelComercial } from '../utils/gestionCampanaAccess'

const RequirePanelComercialAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessPanelComercial(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequirePanelComercialAccess
